import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { JsonPatchOperation } from '../interfaces/json-patch-operation';
import { format } from 'date-fns';

@Injectable({ providedIn: 'root' })
export class HttpHelperService {
  private readonly _serviceName = 'HttpHelperService';

  constructor(private http: HttpClient) {}

  /**
   * Updates a portion of a model (using JSON Patch Notation)
   */
  public patch(url: string, patchDocument: JsonPatchOperation[]) {
    return this.http.patch(url, patchDocument);
  }

  /**
   * Converts an object to HTTP Params object and formats dates to MM/DD/YYYY
   */
  public convertToHttpParams(item: any) {
    let params = new HttpParams();

    if (item) {
      for (const prop in item) {
        if (item.hasOwnProperty(prop)) {
          let val = item[prop];
          if (val instanceof Date) {
            val = format(val, 'MM/dd/yyyy');
          }
          params = params.append(prop, val);
        }
      }
    }

    return params;
  }
}